import React from 'react';
import { connect } from 'react-redux';
import { Box, DataTable } from '../../../../common/components';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { FormControl, Row, Col } from 'react-bootstrap';
import { push } from 'react-router-redux';
import {
  getBrokerId,
  isBroker,
  isBrokerOrganisation,
  isOwner,
} from '../../../auth/redux/authActions';
import formatDateTime from '../../../../helpers/formatDateTime';
import getStatus from '../../../../schemas/policy';
import FilterContainer from '../FilterContainer/FilterContainer';
import { AdditionalFilters } from '../PolicyList/AdditionalFilters/AdditionalFilters';

const ApplicationList = ({ goTo, applyFilter, filters, sourceKey }) => {
  const handleRowClick = (row) => {
    goTo('/policies/applications/' + row.id);
  };

  const tableKey = 'applications' + sourceKey;

  const handleUpdateFilter = (value, filterName) => {
    applyFilter(tableKey, `filter[${filterName}]`, value);
  };

  const handleSearchUpdate = (event) => {
    applyFilter(tableKey, 'filter[quote.reference]', event.target.value);
  };

  const quoteFilter = [
    {
      type: 'filter[status]',
      value: 'applied,quote,issued',
    },
    {
      type: 'filter[quote.type]',
      value: 'new business',
    },
  ];
  const autoFilters = filters ? filters.concat(quoteFilter) : quoteFilter;
  const colSize = isBrokerOrganisation() ? 3 : 4;

  if (isBroker()) {
    autoFilters.push({ type: 'filter[broker]', value: getBrokerId() });
  }

  return (
    <>
      <Box>
        <Row>
          <Col sm={colSize}>
            <FilterContainer label={'Reference'}>
              <FormControl onChange={handleSearchUpdate} />
            </FilterContainer>
          </Col>
        </Row>
        <AdditionalFilters colSize={colSize} onFilterUpdate={handleUpdateFilter} />
      </Box>
      <Box>
        <DataTable
          source="local/policies/applications"
          name={tableKey}
          showTotal
          autoFilters={autoFilters}
          onRowSelect={handleRowClick}
        >
          <TableHeaderColumn dataField="id" isKey hidden />
          <TableHeaderColumn
            dataField="quote_reference"
            width={isOwner() || isBroker() ? '12%' : '33%'}
          >
            Reference
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="insured"
            width={isOwner() || isBroker() ? '18%' : '33%'}
          >
            Insured
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="channel_name"
            width={isOwner() || isBroker() ? '12%' : '33%'}
          >
            Channel
          </TableHeaderColumn>
          {(isOwner() || isBroker()) && (
            <TableHeaderColumn dataField="source_name" width={'12%'}>
              Source
            </TableHeaderColumn>
          )}
          {(isOwner() || isBroker()) && (
            <TableHeaderColumn dataField="broker_name" width={'12%'}>
              Broker
            </TableHeaderColumn>
          )}
          {(isOwner() || isBroker()) && (
            <TableHeaderColumn dataField="user_name" width={'12%'}>
              User
            </TableHeaderColumn>
          )}
          <TableHeaderColumn
            dataField="created_at"
            dataFormat={formatDateTime}
            dataSort
            width={'120px'}
          >
            Quote Date
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="status"
            dataFormat={getStatus}
            dataSort
            width={'100px'}
          >
            Status
          </TableHeaderColumn>
        </DataTable>
      </Box>
    </>
  );
};

export default connect(
  (state) => ({
    auth: state.auth,
  }),
  {
    goTo: push,
    applyFilter: applyFilter,
  },
)(ApplicationList);
